
import Vue from 'vue'
import UITitle from "@/components/UI/Text/UITitle.vue"
import {  mapState } from 'vuex';
import { EStoreType } from '@/enums/EStoreType';
import _requestHelper from '@/apiManager/_requestHelper';
import ItemsSliderWithTitle from '@/components/Items/ItemsSliderWithTitle.vue';
import Breadcrumbds from '@/components/UI/Breadcrumbs.vue';
import {
    buildCanonicalUrl,
    buildBreadcrumbItemsFromRoute,
    buildBreadcrumbListJsonLd,
    buildCollectionPageJsonLd,
    buildSeoMeta,
    buildSeoTitle,
    formatSeoText,
    getRuntimeSeoConfig,
    getSeoOrigin
} from '@/helpers/seoMetaHelper';
import { canUseSelectedStore, ensureSelectedStoreForRoute } from '@/helpers/ssrStorefrontHelper';

export default Vue.extend({
    props: {
        departmentId: {
            required: true
        },
        departmentName: {
            required: true
        },
    },

    components: {
        "ui-title": UITitle,
        ItemsSliderWithTitle,    
        "breadcrumbds": Breadcrumbds,    
    },

    metaInfo: function() {
        const partnerSettings = (this as any).partnerSettings || {};
        const vueAppConfig = getRuntimeSeoConfig();
        const origin = getSeoOrigin(this);
        const partnerName = partnerSettings.partnerName || vueAppConfig.VUE_APP_Title || "Online Store";
        const selectedStoreDetails = (this as any).selectedStoreDetails || {};
        const storeName = selectedStoreDetails.displayName || partnerName;
        const pageName = formatSeoText((this as any).departmentName) || "Departments";
        const title = buildSeoTitle({
            primary: pageName,
            siteName: storeName,
            descriptor: "Categories",
            city: selectedStoreDetails.address && selectedStoreDetails.address.city
        });
        const description = `Browse ${pageName} categories online from ${storeName}.`;
        const keywords = partnerSettings.seoKeywords || vueAppConfig.VUE_APP_Meta_Keywords || "";
        const image =
            partnerSettings.seoImageUrl ||
            partnerSettings.appBarLogoUrl ||
            partnerSettings.logoUrl ||
            "";
        const canonicalUrl = buildCanonicalUrl(this);
        const structuredData: any[] = [
            buildCollectionPageJsonLd({
                name: title,
                description,
                url: canonicalUrl,
                image,
                siteName: partnerName
            })
        ];
        const breadcrumbJsonLd = buildBreadcrumbListJsonLd(
            buildBreadcrumbItemsFromRoute(this.$route, this.$router, origin, this)
        );

        if (breadcrumbJsonLd) {
            structuredData.push(breadcrumbJsonLd);
        }

        return buildSeoMeta({
            title,
            description,
            keywords,
            image,
            canonicalUrl,
            structuredData
        });
    },

    data : () => ({
        loading: false as boolean,
        listOfSubcategories: [] as any[]
    }),

    computed: {
        ...mapState("partner", ["partnerSettings"]),
        ...mapState("store", ["selectedStoreDetails"])
    },

    methods: {

        async getCategoriesList() {
            await ensureSelectedStoreForRoute(this);

            if (!canUseSelectedStore(this)) {
                return;
            }

            this.$emit("loadingState", true);
            this.loading = true;
            
            await _requestHelper({
                method: "post",
                url: "items/categories-page",
                loaderKey: "",
                data: {
                    branchId: (this as any).selectedStoreDetails.id,
                    isLight: (this as any).selectedStoreDetails.storeType == EStoreType.Convenient,
                    departmentId: this.departmentId
                },

                successCallback: (listOfSubcategories: any) => {
                    this.listOfSubcategories = listOfSubcategories.categories;
                }
            });

            this.loading = false;
            this.$emit("loadingState", false);
        },
    },

    watch: {
        async departmentId() {
            await this.getCategoriesList();
        }
    },

    async mounted() {
        if (this.listOfSubcategories.length === 0) {
            await this.getCategoriesList();
        }
    }

})
